import React, { Component, useEffect, useState } from "react";

// reactstrap components
import { Card, Table, Row, Col, Nav, Dropdown } from "react-bootstrap";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
import API from "api.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// core components
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

// import { thead, tbody } from "variables/general";
import TopNavPills from "components/SectionalTest/TopNavPills";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import ArrowIcon from "../assets/images/images_new/sidebar-icons/06.svg";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";
import MockPagination from "components/Question/Mocks/Pagination";

// class MockPending extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       activeTab: 0,
//       all_ok: true,
//       all_ok1: true,
//     };
//   }

//   componentDidMount() {

//     let isChrome =
//       /Chrome/.test(navigator.userAgent) &&
//       /Google Inc/.test(navigator.vendor) &&
//       !/Chromium/.test(navigator.userAgent);
//     let all_ok1 = isChrome ? true : false;
//     if (navigator.getUserMedia === undefined) {
//       this.setState({ all_ok: false, all_ok1: false });
//     } else {
//       navigator.getUserMedia(
//         { audio: true },
//         () => {
//           console.log("Permission Granted");
//           this.setState({ all_ok1: all_ok1 });
//         },
//         () => {
//           this.setState({ all_ok1: false });
//           console.log("Permission Denied");
//         }
//       );
//     }

//     let new_format = 0;
//     if (this.props.location.pathname === "/admin/pending/new-sectional-tests") {
//       new_format = 1;
//     }

//     this.getMocks(new_format);
//   }

//   componentDidUpdate(prevProps) {
//     if (this.props.location.pathname !== prevProps.location.pathname) {
//       if (
//         this.props.location.pathname === "/admin/pending/new-sectional-tests"
//       ) {
//         this.getMocks(1);
//       } else if (this.props.location.pathname === "/admin/pending") {
//         this.getMocks(0);
//       }
//     }
//   }

//   getMocks = (new_format) => {
//     API({
//       method: "GET",
//       url: "pending/mock?new_format=" + new_format,
//     })
//       .then((data) => {
//         let tab = 1;
//         // this.props.location.pathname === "/admin/pending/new-sectional-tests" &&
//         //   (tab = 2);
//         this.toggle(tab);
//         this.setState({ data: data.data });
//       })
//       .catch(() => {});
//   };

//   toggle = (tab) => {
//     let all_ok = true;
//     if (this.state.activeTab !== tab) {
//       this.setState({ activeTab: tab }, function () {
//         if ([1, 5].includes(this.state.activeTab)) {
//           all_ok = this.state.all_ok1;
//         } else {
//           all_ok = true;
//         }
//         this.setState({ all_ok: all_ok });
//       });
//     }
//   };

//   redirectToMock = (id, event) => {
//     event.preventDefault();
//     const index = event.target.attributes["data-id"].value;
//     const { mock } = this.state.data[index];
//     const { new_format } = mock;
//     this.props.history.push({
//       pathname: `/admin/${new_format ? "sectionalTest" : "test"}`,
//       state: {
//         id,
//         pending: 1,
//       },
//     });
//   };

//   redirectToFullMock = (id, event) => {
//     event.preventDefault();
//     this.props.history.push({
//       pathname: `/admin/fulltest`,
//       state: {
//         id,
//         pending: 1,
//       },
//     });
//   };

//   render() {
//     return (
//       <>
//         <Helmet htmlAttributes>
//           <title>Top PTE Training Institute</title>
//         </Helmet>
//         {true && (
//           <div className="content tabs-content p-0 mock-test">
//             <DashboardHeader title="Pending Mock Test" />
//             <Row className="outer-wrapper">
//               <Col xs={12}>
//                 <Card className="border-0 card-wrapper">
//                   <div className="dailytask-header">
//                     <div className="dailytask-title">Pending Mock Test</div>
//                     <div>
//                       {this.props.location.pathname !==
//                         "/admin/pending/new-sectional-tests" && (
//                         <Nav
//                           className="nav-pills-primary nav-pills-icons justify-content-center"
//                           pills
//                           role="tablist"
//                           tabs
//                         >
//                           <Nav.Item>
//                             <Nav.Link
//                               className={
//                                 this.state.activeTab === 1 ? "active" : ""
//                               }
//                               onClick={() => {
//                                 this.toggle(1);
//                               }}
//                             >
//                               Speaking
//                             </Nav.Link>
//                           </Nav.Item>
//                           <Nav.Item>
//                             <Nav.Link
//                               className={
//                                 this.state.activeTab === 2 ? "active" : ""
//                               }
//                               onClick={() => {
//                                 this.toggle(2);
//                               }}
//                             >
//                               Writing
//                             </Nav.Link>
//                           </Nav.Item>
//                           <Nav.Item>
//                             <Nav.Link
//                               className={
//                                 this.state.activeTab === 3 ? "active" : ""
//                               }
//                               onClick={() => {
//                                 this.toggle(3);
//                               }}
//                             >
//                               Reading
//                             </Nav.Link>
//                           </Nav.Item>
//                           <Nav.Item>
//                             <Nav.Link
//                               className={
//                                 this.state.activeTab === 4 ? "active" : ""
//                               }
//                               onClick={() => {
//                                 this.toggle(4);
//                               }}
//                             >
//                               Listening
//                             </Nav.Link>
//                           </Nav.Item>
//                           <Nav.Item>
//                             <Nav.Link
//                               className={
//                                 this.state.activeTab === 5 ? "active" : ""
//                               }
//                               onClick={() => {
//                                 this.toggle(5);
//                               }}
//                             >
//                               Full Mock Test
//                             </Nav.Link>
//                           </Nav.Item>
//                         </Nav>
//                       )}
//                       {this.props.location.pathname ===
//                         "/admin/pending/new-sectional-tests" && (
//                         <TopNavPills
//                           activeTab={this.state.activeTab}
//                           toggle={this.toggle}
//                         />
//                       )}
//                      </div>
//                   </div>
//                   <Card.Body className="p-0">
//                     {!this.state.all_ok && (
//                       <div className="mt-5">
//                         <ChromeCheck />
//                       </div>
//                     )}
//                     {this.state.all_ok && (
//                       <div className="table-wrapper">
//                         <Table>
//                           <thead className="text-primary">
//                             <tr>
//                             <th className="table-counting">#</th>
//                               <th className="">Title</th>
//                               <th className="">Description</th>
//                               <th className="">Time</th>
//                               <th className="">Action</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {this.state.data.map((val, key) => {
//                               if (
//                                 val?.mock?.category?.id == this.state.activeTab
//                               ) {
//                                 return (
//                                   <tr>
//                                     <td>{key + 1}</td>
//                                     <td className="">{val?.mock?.title}</td>
//                                     <td className="">{val?.description}</td>
//                                     <td className="">{val?.mock?.time}</td>
//                                     <td className="">
//                                       {val.mock.type === 0 || val.mock.id ? (
//                                         <>
//                                           {val.mock.category.id !== 5 && (
//                                             <a
//                                               href="#"
//                                               data-id={key}
//                                               onClick={this.redirectToMock.bind(
//                                                 this,
//                                                 val.mock.id
//                                               )}
//                                               className="nav-link"
//                                               activeClassName="active"
//                                             >
//                                               <div className="view-btn" data-id={key}><img className='view-btn-icon' src={ArrowIcon} alt="Resume Test" />Resume Test</div>
//                                             </a>
//                                           )}
//                                           {val.mock.category.id === 5 && (
//                                             <a
//                                               href="#"
//                                               onClick={this.redirectToFullMock.bind(
//                                                 this,
//                                                 val.mock.id
//                                               )}
//                                               className="nav-link view-btn"
//                                               activeClassName="active"
//                                             >
//                                              <img className='view-btn-icon' src={ArrowIcon} alt="Resume Test" />Resume Test
//                                             </a>
//                                           )}
//                                         </>
//                                       ) : (
//                                         <>
//                                           <Link to="/admin/plans">
//                                             Subscribe to mock plan
//                                           </Link>
//                                         </>
//                                       )}
//                                     </td>
//                                   </tr>
//                                 );
//                               }
//                             })}
//                           </tbody>
//                         </Table>
//                       </div>
//                     )}
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>
//           </div>
//         )}
//       </>
//     );
//   }
// }

// export default MockPending;

const MockPending = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [all_ok, setAll_ok] = useState(true);
  const [all_ok1, setAll_ok1] = useState(true);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [displaying_items, setDisplaying_items] = useState(10);

  useEffect(() => {
    let all_ok1_value = true;

  if (navigator.mediaDevices.getUserMedia === undefined) {
      setAll_ok(false);
      setAll_ok1(false);
    } else {
      navigator.mediaDevices.getUserMedia(
        { audio: true },
        () => {
          // console.log("Permission Granted");
          setAll_ok1(all_ok1_value);
        },
        () => {
          setAll_ok1(false);
          // console.log("Permission Denied");
        }
      );
    }

    let new_format = 0;
    if (location.pathname === "/admin/extensive-pending/new-sectional-tests") {
      new_format = 1;
    }

    getMocks(new_format);
  }, [location.pathname]);

  const getMocks = (new_format) => {
    setLoading(true);
    API({
      method: "GET",
      url: "pending/mock?new_format=" + new_format,
      timeout: 60000,
    })
      .then((data) => {
       let tab = location.pathname !== "/admin/extensive-pending/new-sectional-tests" ? 5 : 1;
        toggle(tab);
        const allData = data.data;
        setData(allData);
        setTotal(allData.filter((item) => item.mock && item.mock.category && item.mock.category.id === tab).length);
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      });
  };

  const toggle = (tab) => {
    let all_ok_value = true;
    if (activeTab !== tab) {
      setActiveTab(tab);
      setPage(1);
      // if ([1, 5].includes(tab)) {
      //   all_ok_value = all_ok1;
      // } else {
      //   all_ok_value = true;
      // }
      setAll_ok(all_ok_value);
    }
  };

  const redirectToMock = (id, index, event) => {
    event.preventDefault();
    const { mock } = data[index];
    const { new_format } = mock;
    navigate(`/admin/${new_format ? "sectionalTest" : "test"}`, {
      state: {
        id,
        pending: 1,
      },
    });
  };

  const redirectToFullMock = (id, event) => {
    event.preventDefault();
    // navigate(`/admin/fulltest`, {
    //   state: {
    //     id,
    //     pending: 1,
    //   },
    // });
    navigate(`/admin/fulltest/${id}/1`, {
      state: { id, pending: 1 },
    });
  };

  useEffect(() => {
    setTotal(data.filter((item) => item.mock && item.mock.category && item.mock.category.id === activeTab).length);
    setPage(1);
  }, [activeTab, data]);

  const updateListingItems = (items, page) => {
    setDisplaying_items(items);
    setPage(page);
  };

  const paginationChange = (page) => {
    setPage(page);
  };

  const getPaginatedData = () => {
    const filteredData = data.filter((item) => item.mock && item.mock.category && item.mock.category.id === activeTab);
    const startIndex = (page - 1) * displaying_items;
    const endIndex = startIndex + displaying_items;
    return filteredData.slice(startIndex, endIndex);
  };


  // console.log("Page:", page, "Displaying Items:", displaying_items);
  // console.log("Paginated Data:", getPaginatedData());

  return (
    <>
      <Helmet htmlAttributes>
        <title>Top PTE Training Institute</title>
      </Helmet>
      {true && (
        <div className="content tabs-content p-0 mock-test">
          <DashboardHeader title={location.pathname === "/admin/extensive-pending/new-sectional-tests" ? "Extensive Pending Mock Test" : "Pending Mock Test"} />
          <Row className="outer-wrapper">
            <Col xs={12} className="sp-0">
              <Card className={`border-0 card-wrapper m-0 m-md-4 w-auto ${getPaginatedData()?.length > 0 ? "listing_height_test" : ""}`}>

                <div className="dailytask-header mt-2">
                  <div className="dailytask-title px-3">{location.pathname === "/admin/extensive-pending/new-sectional-tests" ? "Extensive Pending Mock Test" : "Pending Mock Test"}</div>
                  <div className="px-3">
                    {location.pathname === "/admin/extensive-pending/new-sectional-tests" && <div className="d-md-none mb-3">
                      <Dropdown className="w-100 mobile-category-dropdown">
                        <Dropdown.Toggle variant="none" id="dropdown-basic" className="w-100 text-start d-flex justify-content-between align-items-center">
                          <span>
                            {[
                              "Speaking",
                              "Writing",
                              "Reading",
                              "Listening",
                              "Full Mock Test",
                            ][activeTab - 1]}
                          </span>
                          <i className="fa fa-chevron-down small opacity-50"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {(location.pathname === "/admin/extensive-pending/new-sectional-tests"
                            ? ["Speaking", "Writing", "Reading", "Listening"]
                            : []
                          ).map((label, idx) => (
                            <Dropdown.Item
                              key={idx}
                              active={activeTab === idx + 1}
                              onClick={() => toggle(idx + 1)}
                            >
                              {label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>}

                    <div className="d-none d-md-block">
                      {/* {location.pathname !==
                        "/admin/extensive-pending/new-sectional-tests" && (
                          <Nav
          Test                  className="nav-pills-primary nav-pills-icons justify-content-center"
                            pills
                            role="tablist"
                            // tabs
                            variant="tabs"
                          >
                            <Nav.Item>
                              <Nav.Link
                                className={activeTab === 1 ? "active" : ""}
                                onClick={() => toggle(1)}
                              >
                                Speaking
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={activeTab === 2 ? "active" : ""}
                                onClick={() => toggle(2)}
                              >
                                Writing
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={activeTab === 3 ? "active" : ""}
                                onClick={() => toggle(3)}
                              >
                                Reading
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={activeTab === 4 ? "active" : ""}
                                onClick={() => toggle(4)}
                              >
                                Listening
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={activeTab === 5 ? "active" : ""}
                                onClick={() => toggle(5)}
                              >
                                Full Mock Test
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        )} */}
                      {location.pathname ===
                        "/admin/extensive-pending/new-sectional-tests" && (
                          <TopNavPills activeTab={activeTab} toggle={toggle} />
                        )}
                    </div>
                  </div>
                </div>
                <Card.Body className={`p-0 ${getPaginatedData()?.length > 0 ? "listing_height listing_height_test" : ""}`}>
                  {!all_ok && (
                    <div className="mt-5">
                      <ChromeCheck />
                    </div>
                  )}
                  {all_ok && (
                    <div className="table-wrapper">
                      {loading ? (
                        <div className="text-center p-5">
                          <Spinner />
                        </div>
                      ) : getPaginatedData()?.length === 0 ? (
                        <div className="p-3">
                          <EmptyData text={"No Pending Tests Found"} />
                        </div>
                      ) : (
                        <>
                          <div className="d-none d-md-block">
                            <Table>
                              <thead className="text-primary">
                                <tr>
                                  <th className="table-counting">#</th>
                                  <th className="">Title</th>
                                  <th className="">Description</th>
                                  <th className="">Time</th>
                                  <th className="">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {getPaginatedData().map((val, key) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        {(page - 1) * displaying_items + key + 1}
                                      </td>
                                      <td className="">{val?.mock?.title}</td>
                                      <td className="">{val?.mock?.description}</td>
                                      <td className="">{Math.round(val?.time)}</td>
                                      <td className="">
                                        {val.mock.type === 0 || val.mock.id ? (
                                          <>
                                            {val.mock.category.id !== 5 && (
                                              <Link
                                                to="#"
                                                data-id={key}
                                                onClick={(e) => redirectToMock(val.mock.id, data.indexOf(val), e)}
                                                className="nav-link"
                                                activeClassName="active"
                                              >
                                                <div
                                                  className="view-btn"
                                                  data-id={key}
                                                >
                                                  <img
                                                    className="view-btn-icon"
                                                    src={ArrowIcon}
                                                    alt="Resume Test"
                                                  />
                                                  Resume Test
                                                </div>
                                              </Link>
                                            )}
                                            {val.mock.category.id === 5 && (
                                              <Link
                                                to="#"
                                                onClick={redirectToFullMock.bind(
                                                  null,
                                                  val.mock.id
                                                )}
                                                className="nav-link view-btn"
                                                activeClassName="active"
                                              >
                                                <img
                                                  className="view-btn-icon"
                                                  src={ArrowIcon}
                                                  alt="Resume Test"
                                                />
                                                Resume Test
                                              </Link>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <Link to="/admin/plans">
                                              Subscribe to mock plan
                                            </Link>
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>

                          <div className="mobile-table d-md-none mt-3">
                            {getPaginatedData().map((val, key) => {
                              return (
                                <Card className="border-0 card-wrapper m-0 mb-3 p-3 shadow-sm rounded-4" key={key}>
                                  <div className="d-flex justify-content-between align-items-start mb-2">
                                    <h6 className="fw-bold mb-0 pe-2" style={{ fontSize: '1.1rem' }}>{val?.mock?.title}</h6>
                                    <span className="badge rounded-pill px-3 py-2" style={{ backgroundColor: '#A3D951', color: '#fff', fontSize: '0.8rem' }}>
                                      Time: {Math.round(val?.time)}min
                                    </span>
                                  </div>
                                  <p className="text-muted small mb-3">{val?.mock?.description}</p>

                                  <div className="w-100">
                                    {val.mock.type === 0 || val.mock.id ? (
                                      <>
                                        {val.mock.category.id !== 5 && (
                                          <Link
                                            to="#"
                                            onClick={(e) => redirectToMock(val.mock.id, data.indexOf(val), e)}
                                            className="nav-link p-0 w-100"
                                          >
                                            <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                              <img
                                                className="view-btn-icon"
                                                src={ArrowIcon}
                                                alt="Resume Test"
                                                style={{ margin: '0 8px 0 0' }}
                                              />
                                              Resume
                                            </div>
                                          </Link>
                                        )}
                                        {val.mock.category.id === 5 && (
                                          <Link
                                            to="#"
                                            onClick={redirectToFullMock.bind(
                                              null,
                                              val.mock.id
                                            )}
                                            className="nav-link p-0 w-100"
                                          >
                                            <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                              <img
                                                className="view-btn-icon"
                                                src={ArrowIcon}
                                                alt="Resume Test"
                                                style={{ margin: '0 8px 0 0' }}
                                              />
                                              Resume
                                            </div>
                                          </Link>
                                        )}
                                      </>
                                    ) : (
                                      <Link
                                        to="/admin/plans"
                                        className="nav-link p-0 w-100"
                                      >
                                        <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                          Subscribe
                                        </div>
                                      </Link>
                                    )}
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </>
                      )}

                      <MockPagination
                        total={total}
                        listing={displaying_items}
                        updateListingItems={updateListingItems}
                        page={page}
                        paginationChange={paginationChange}
                      />
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default MockPending;
